"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictionQuestionReleaseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const PredictionQuestionReleaseButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.iconButton, question } = props;
    const handleClick = () => {
        console.info("CLICK");
    };
    if (!question.endTimestamp) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleClick, icon: icons_material_1.AttachMoney, message: "form.buttons.releaseFunds", className: className, dataTestId: "PredictionQuestionReleaseButton", disabled: disabled, variant: variant }));
};
exports.PredictionQuestionReleaseButton = PredictionQuestionReleaseButton;
//# sourceMappingURL=index.js.map